<template>
    <div v-if="qrCodeURL" class="pa-3">
      <!-- <v-alert
      color="#e3b446"
      border="left"
      elevation="1"
      colored-border
    > -->
    <p style="color: red;font-size: 18px;font-weight: bold;"><v-icon v-if="formattedTime" color="red" class="pb-1">mdi-clock</v-icon> {{ formattedTime }}</p>
    <!-- </v-alert> -->
        <div style="display: flex;justify-content: center;margin-bottom: 20px;">
          <v-card style="width: 70%;padding-top: 30px;border-radius: 20px !important;">
            <QrcodeVue :value="qrCodeURL" :size="size" level="M"></QrcodeVue><br>
          </v-card>
        </div>
        <!-- <div>3:00</div> -->
        <div>
            <div  cols="10" xs="10" sm="10" md="8" lg="8">
                <v-text-field
                v-model="qrCodeURL"
                label="Copy Link"
                ref="textToCopyformView"
                outlined
                dense
                readonly
                ></v-text-field>
            </div >
            <div  class="text-center" cols="1" xs="1" sm="1" md="1" lg="1">
              <v-btn :color="$bgColor"
              :text="$isTargetShop()"
              :tile="$isTargetShop()"
              :elevation="$isTargetShop() ? 0 : 2"
              :style="$isTargetShop() ? 'color:#000' : ''"
              block
              dark @click="copyTextformView">{{ $t("message.copyLink") }}<v-icon>mdi-content-copy</v-icon></v-btn>
            </div >
        </div >
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import QrcodeVue from 'qrcode.vue'
export default {
  name: 'QRCodeUsePackage',
  props: {
    shopIdProp: { type: [String, Number], default: '' },
    token: { type: String, default: '' },
    memberId: { type: String, default: '' },
    tpk: { type: String, default: '' },
    handler: { type: Function, default: null }
  },
  components: {
    QrcodeVue
  },
  data () {
    return {
      member: null,
      qrCodeURL: null,
      size: 200,
      profile: null,
      timeLeft: 180,
      formattedTime: '',
      timer: null
    }
  },
  async mounted () {
    this.member = this.GET_MEMBERINFO()
    this.profile = this.getLiffProfile()
    this.startTimer()

    this.qrCodeURL = this.ADMIN_IP + `/Master/PackageQRcode?shopId=${this.shopIdProp}&token=${this.token}&memberId=${this.memberId}&tpk=${this.tpk}`
  },
  methods: {
    ...mapGetters('lineStore', ['liffIsReady', 'getLiffProfile']),
    ...mapGetters('memberStore', ['GET_MEMBERINFO']),

    copyTextformView () {
      let textToCopyformUpdate = this.$refs.textToCopyformView.$el.querySelector('input')
      textToCopyformUpdate.select()
      document.execCommand('copy')
    },
    startTimer () {
      this.timer = setInterval(() => {
        this.timeLeft--
        this.formattedTime = this.formatTime(this.timeLeft)
        if (this.timeLeft <= 0) {
          clearInterval(this.timer)
          // ทำอย่างไรก็ตามเมื่อเวลาหมด
        }
      }, 1000)
    },
    formatTime (seconds) {
      let minutes = Math.floor(seconds / 60)
      let remainingSeconds = seconds % 60
      let formattedSeconds = remainingSeconds < 10 ? '0' + remainingSeconds : remainingSeconds
      return `0${minutes}:${formattedSeconds}`
    },
    test () {
      // stop timer and clear formatted time when parent requests cleanup
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
      this.formattedTime = ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/HomeCUSTOM/Package/Qrcode.vue